import { render, staticRenderFns } from "./WpTestItem.vue?vue&type=template&id=47228298&scoped=true"
import script from "./WpTestItem.vue?vue&type=script&lang=js"
export * from "./WpTestItem.vue?vue&type=script&lang=js"
import style0 from "./WpTestItem.vue?vue&type=style&index=0&id=47228298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47228298",
  null
  
)

export default component.exports